"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useGetNovageSkincareConfiguration = require("./useGetNovageSkincareConfiguration");
Object.keys(_useGetNovageSkincareConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetNovageSkincareConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetNovageSkincareConfiguration[key];
    }
  });
});
var _useGetRevieveConfiguration = require("./useGetRevieveConfiguration");
Object.keys(_useGetRevieveConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetRevieveConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetRevieveConfiguration[key];
    }
  });
});
var _useLocale = require("./useLocale");
Object.keys(_useLocale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useLocale[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useLocale[key];
    }
  });
});
var _useOnHrefClick = require("./useOnHrefClick");
Object.keys(_useOnHrefClick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useOnHrefClick[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useOnHrefClick[key];
    }
  });
});
var _useOnPDPHrefClick = require("./useOnPDPHrefClick");
Object.keys(_useOnPDPHrefClick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useOnPDPHrefClick[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useOnPDPHrefClick[key];
    }
  });
});
var _useRedirectToPdp = require("./useRedirectToPdp");
Object.keys(_useRedirectToPdp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useRedirectToPdp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useRedirectToPdp[key];
    }
  });
});
var _useRevieve = require("./useRevieve");
Object.keys(_useRevieve).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useRevieve[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useRevieve[key];
    }
  });
});
var _useRevieveAdvisor = require("./useRevieveAdvisor");
Object.keys(_useRevieveAdvisor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useRevieveAdvisor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useRevieveAdvisor[key];
    }
  });
});
var _useRevieveScript = require("./useRevieveScript");
Object.keys(_useRevieveScript).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useRevieveScript[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useRevieveScript[key];
    }
  });
});
var _useSessionStorage = require("./useSessionStorage");
Object.keys(_useSessionStorage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useSessionStorage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useSessionStorage[key];
    }
  });
});
var _useTranslations = require("./useTranslations");
Object.keys(_useTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useTranslations[key];
    }
  });
});
